import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

function DocumentIcon({ icon }) {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <link rel="shortcut icon" href={icon} />
    </Helmet>
  );
}

DocumentIcon.propTypes = {
  icon: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    icon: state.ui.favicon
  };
}

export default connect(mapStateToProps)(DocumentIcon);
